import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';

function isElementInViewportTopBottom(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.bottom <=
      (window.innerHeight ||
        document.documentElement.clientHeight) /*or $(window).height() */
  );
}

function isElementInViewportLeftRight(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.left >= 0 &&
    rect.right <=
      (window.innerWidth ||
        document.documentElement.clientWidth) /*or $(window).width() */
  );
}

export default class UIDropDownButton extends Component {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    bClassName: PropTypes.string,
    className: PropTypes.string,
    hideToggle: PropTypes.bool,
    isHoverButton: PropTypes.bool,
    mouseLeave: PropTypes.bool,
    style: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  state = {
    show: false,
    position: 'bottom',
    positionLeft: true,
  };

  componentDidUpdate(prevProps, prevState) {
    const menu = this.refs.menu;
    if (prevState.show === this.state.show) return;
    this.setState({
      position: !isElementInViewportTopBottom(menu) ? 'top' : 'bottom',
      positionLeft: isElementInViewportLeftRight(menu),
    });
  }

  componentDidMount() {
    document.body.addEventListener('click', this.handleDocumentClick, false);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleDocumentClick, false);
  }

  handleOnClick = e => {
    e.stopPropagation();
    this.setState({ show: !this.state.show });
  };

  mouseLeaveEvent = e => {
    const { mouseLeave } = this.props;
    e.preventDefault();
    if (mouseLeave) {
      this.setState({ show: false });
    }
  };

  handleDocumentClick(e) {
    const ctn = this.refs.dropDownContainer;
    const btn = this.refs.button;
    if (ctn && e.target === btn) {
      e.preventDefault();
    } else {
      this.setState({ show: false });
    }
  }

  _handleRemove = e => {
    const { handleRemove } = this.props;

    handleRemove();
    e.stopPropagation();
  };

  render() {
    const {
      disabled,
      handleRemove,
      icon,
      children,
      skipAssignment,
      styleOverrides,
    } = this.props;
    const style = { ...this.props.style } || {};

    if (!skipAssignment) {
      if (this.state.position === 'top') {
        style.bottom = '100%';
        style.top = 'auto';
      }

      if (!this.state.positionLeft) {
        style.right = 0;
        style.left = 'auto';
      }
    }

    const classes = classNames('dropdown', this.props.className, {
      show: this.state.show,
    });

    // console.log('cls', classes, this.state.show);
    const showToggle = this.props.hideToggle ? null : 'dropdown-toggle';

    const buttonClasses = classNames(
      'btn',
      'dropdown-btn',
      showToggle,
      this.props.bClassName,
    );

    const divClasses = classNames('dropdown-menu', { show: this.state.show });

    let iconToDisplay = null;

    if (icon) {
      iconToDisplay = <FontAwesomeIcon size="1x" icon={icon} />;
    } else if (handleRemove) {
      iconToDisplay = (
        <i
          onClick={this._handleRemove}
          className={classNames('fa', 'fa-times')}
        />
      );
    }

    // console.log('children count', React.Children.count(children));
    const hasChildren = React.Children.count(children);
    // const hasChildren = Array.isArray(children) && children.filter(item => item !== null).length > 0;
    if (!hasChildren) {
      return null;
    }

    let clickHandler;

    if (!disabled) {
      clickHandler = this.handleOnClick;
    }

    return (
      <div
        ref="dropDownContainer"
        onMouseLeave={this.mouseLeaveEvent}
        className={classes}
      >
        <div
          ref="menu"
          style={style}
          className={divClasses}
          aria-labelledby="dropdownMenu1"
        >
          {this.props.children}
        </div>
        <button
          ref="button"
          className={buttonClasses}
          style={styleOverrides || {}}
          onClick={clickHandler}
          type="button"
          aria-haspopup="true"
          aria-expanded="false"
          data-test={this.props.dataTest}
        >
          {iconToDisplay} {this.props.title}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/DropDownButton.js